import { AlertTriangle, Check, LoaderCircle } from "lucide-react";
import type { SaveStatus } from "../persistence/autosave_controller";

export interface SaveStatusViewProps {
  readonly status: SaveStatus;
  readonly onRecovery?: () => void;
  readonly onRetry: () => void;
}

/** Presents autosave state with text, icon, live semantics, and recovery action. */
export function SaveStatusView({ status, onRecovery, onRetry }: SaveStatusViewProps) {
  if (status.kind === "idle") {
    return <span className="save-status save-status--idle">Ready</span>;
  }

  if (status.kind === "saving") {
    return (
      <span className="save-status" role="status">
        <LoaderCircle className="save-status__spinner" aria-hidden="true" />
        Saving…
      </span>
    );
  }

  if (status.kind === "saved") {
    return (
      <span className="save-status" role="status" title={status.savedAt.toLocaleString()}>
        <Check aria-hidden="true" />
        Saved
      </span>
    );
  }

  return (
    <span className="save-status save-status--failed" role="alert">
      <AlertTriangle aria-hidden="true" />
      <span>{status.message}</span>
      <button type="button" onClick={onRetry}>
        Retry
      </button>
      {onRecovery === undefined ? null : (
        <button type="button" onClick={onRecovery}>
          Recovery options
        </button>
      )}
    </span>
  );
}
